import React from 'react';
import SimpleDialog from 'components/Dialog/SimpleDialog';
import { withState, compose } from 'recompose';
import MagentoCategories from 'components/magento/MagentoCategories';
import { initialMenuState } from 'helpers/initialState';


const CategoryAddDialog = ({
  onClose,
  open,
  updateCategory,
}) => (
  <SimpleDialog onClose={onClose} open={open} hasSubmit={false} title="Add New Category">
    <div style={{ height: 500, overflow: 'auto', width: 400, margin: 'auto' }}>
      <MagentoCategories
        onClick={(cat) => {
          updateCategory({ name: cat.id, categoryName: cat.name })
        }}
      />
    </div>
  </SimpleDialog>);

CategoryAddDialog.propTypes = {};
CategoryAddDialog.defaultProps = {};

export default compose(
  withState('activeTab', 'setActiveTab', 'custom'),
)(CategoryAddDialog);



// WEBPACK FOOTER //
// ./src/pages/Banners/children/CategoryBanners/CategoryAddDialog.js